<div class="scope-row flex items-center flex-col">
  <div class="scope-row-content flex items-center">
    <div
      class="column level-{{ level }}"
      [ngClass]="config?.roleMainColumnClass">
      <commentable
        [c-root-entity]="component"
        [c-entity]="role"
        c-key="name"
        c-type="role">
        {{ role.name }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline || !config?.scopeVersion.isScopeByScenario()"></div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline">
      <commentable
        [c-root-entity]="component"
        [c-entity]="role"
        [c-key]="'scopeMarkRate'"
        [c-type]="'role'">
        {{
          scopeElementsService.roleColumns?.[TableColumnKey.WEIGHTED_RATE]?.isVisible()
            ? (role.getScopeMarkRate()?.amount | convertCurrency: config?.currency)
            : DEFAULT_PLACEHOLDER
        }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline"
      *ngIf="!config?.scopeVersion.identity.costPlus">
      <commentable
        [c-root-entity]="component"
        [c-entity]="role"
        [c-key]="'rateCardRate'"
        [c-type]="'role'">
        {{
          scopeElementsService.roleColumns?.[TableColumnKey.AGENCY_RATE]?.isVisible()
            ? (role.rateCardRate?.amount | convertCurrency: config?.currency)
            : DEFAULT_PLACEHOLDER
        }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline"
      *ngIf="config?.scopeVersion.identity.costPlus">
      <commentable
        [c-root-entity]="component"
        [c-entity]="role"
        [c-key]="'rateCardRate'"
        [c-type]="'role'">
        {{
          config?.userColumns.AGENCY_RATE?.isVisible()
            ? (role.rateCardCost?.amount | convertCurrency: config?.currency)
            : DEFAULT_PLACEHOLDER
        }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.SCOPEMARK_HOURS?.selected">
      <commentable
        [c-root-entity]="component"
        [c-entity]="role"
        [c-key]="'scopeMarkHours'"
        [c-type]="'role'">
        {{ role.getScopeMarkHours() | formatHours }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected">
      <commentable
        [c-root-entity]="component"
        [c-entity]="role"
        [c-key]="'scopeMarkSellingPrice'"
        [c-type]="'role'">
        {{
          role.getScopeMarkSellingPrice()
            ? (role.getScopeMarkSellingPrice().amount | convertCurrency: config?.currency)
            : DEFAULT_PLACEHOLDER
        }}
      </commentable>
    </div>
    <div
      class="column {{ config?.isTimeline ? 'three--columns' : 'one--column' }}"
      [hidden]="!config?.isTimeline && !config?.userColumns.AGENCY_HOURS?.selected">
      <scope-ui-counter
        *ngIf="config?.isEditable"
        [min]="0"
        [max]="9999 * 60"
        [maxLength]="4"
        [majorStep]="60"
        [minorStep]="15"
        [enableMinors]="true"
        [formatDisplayValue]="formatDisplayValue"
        [parseDisplayValue]="parseDisplayValue"
        [initialValue]="role.rateCardMinutes"
        (onUpdateValue)="updateRoleHours($event)" />
      <commentable
        *ngIf="!config?.isEditable"
        [c-root-entity]="component"
        [c-entity]="role"
        [c-key]="'rateCardHours'"
        [c-type]="'role'"
        [c-use-icon]="role.hasAttributeAlterationComment()"
        [c-action]="overrideRateCardRoleHours()"
        [c-action-text]="'Change Hours'"
        [c-action-privilege]="'SCOPE_REVIEW__EDIT_ROLE_HOURS'">
        <ng-container
          *ngTemplateOutlet="
            fieldDifference;
            context: {
              fieldName: 'rateCardTotalHours',
              valueFn: formatHours,
              defaultValue: role.getRateCardHours(),
            }
          ">
        </ng-container>
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline || !config?.scopeVersion.isScopeByScenario()"></div>
    <div
      class="column {{ config?.isTimeline ? 'three--columns' : 'one--column' }}"
      [hidden]="!config?.isTimeline && !config?.userColumns.AGENCY_PRICE?.selected">
      <commentable
        [c-root-entity]="component"
        [c-entity]="role"
        [c-key]="'agencySellingPrice'"
        [c-type]="'role'">
        <ng-container
          *ngTemplateOutlet="
            fieldDifference;
            context: {
              fieldName: 'agencyPrice',
              valueFn: formatPrice,
              defaultValue: role.getUserSellingPrice({ markup: component.costPlusValue })?.amount,
            }
          ">
        </ng-container>
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline || !config?.showActionsColumn"></div>
  </div>
</div>

<ng-template
  #fieldDifference
  let-fieldName="fieldName"
  let-valueFn="valueFn"
  let-defaultValue="defaultValue">
  <scope-field-difference
    [isChangeRequest]="config?.isChangeRequest"
    [fieldName]="fieldName"
    [defaultValue]="defaultValue"
    [changes]="role.changes"
    [getFieldToDisplay]="getFieldToDisplay"
    [showDiff]="showDiff"
    [valueFn]="valueFn" />
</ng-template>
